import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { updateBatchInput } from '../../../actions/SearchParameter.Actions';
import MultiChipInput from '../../../components/MultiChipInput';

class BatchIDField extends Component {
  constructor(props) {
    super(props);
    this.handleUpdateBatchInput = this.handleUpdateBatchInput.bind(this);
  }

  handleUpdateBatchInput({ results }) {
    const { dispatch } = this.props;
    dispatch(updateBatchInput(results));
  }

  render() {
    const { batch: { available, input } } = this.props;

    return (
      <MultiChipInput
        label="Search by Batch ID"
        data={available}
        bindInput={input}
        onChipDelete={this.handleUpdateBatchInput}
        onChipCreate={this.handleUpdateBatchInput}
        onSelectAll={this.handleUpdateBatchInput}
        onDeleteAll={this.handleUpdateBatchInput}
      />
    );
  }
}

BatchIDField.propTypes = {
  dispatch: PropTypes.func.isRequired,
  batch: PropTypes.shape({
    available: PropTypes.arrayOf(PropTypes.string).isRequired,
    input: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired
};

function mapStateToProps({ SearchParameter: { batch } }) {
  return { batch };
}

export default connect(mapStateToProps)(BatchIDField);



// WEBPACK FOOTER //
// ./src/containers/Aside/ImageSearchGroup/BatchIDField.jsx